import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  ElementRef,
  OnInit,
  ViewChild,
  inject,
  signal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { MenuModule } from 'primeng/menu';

import { AuthService } from '../core/service/auth.service';
import { LocalStorageService } from '../core/service/local-storage.service';
import { LocalStorageEnum } from '../shared/enum.ts/local-storage.enum';
import { RoleLabelPipe } from '../shared/pipes/role-label.pipe';
import { LayoutService } from './service/app.layout.service';

@Component({
  selector: 'app-topbar',
  standalone: true,
  imports: [CommonModule, RouterLink, MenuModule, RoleLabelPipe],
  templateUrl: './app.topbar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppTopBarComponent implements OnInit {
  readonly layoutService = inject(LayoutService);
  private readonly authService = inject(AuthService);
  private readonly localStorage = inject(LocalStorageService);
  private readonly destroyRef = inject(DestroyRef);

  /** Raw `Role` enum value from session (for pipe). */
  readonly sessionRole = signal<string | null>(null);

  accountMenuItems: MenuItem[] = [];

  @ViewChild('menubutton') menuButton!: ElementRef;
  @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;
  @ViewChild('topbarmenu') menu!: ElementRef;

  ngOnInit(): void {
    const user = this.localStorage.getItem(LocalStorageEnum.USER) as { roleName?: string } | null;
    this.sessionRole.set(user?.roleName ?? null);

    this.accountMenuItems = [
      {
        label: 'Account',
        items: [
          {
            label: 'Profile',
            icon: 'pi pi-user',
            routerLink: '/profile',
          },
          {
            label: 'Change password',
            icon: 'pi pi-key',
            routerLink: '/change-password',
          },
          {
            separator: true,
          },
          {
            label: 'Sign out',
            icon: 'pi pi-sign-out',
            command: () => this.signOut(),
          },
        ],
      },
    ];
  }

  private signOut(): void {
    this.authService
      .logout()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => this.authService.clearSession(),
        error: () => this.authService.clearSession(),
      });
  }
}
